import { render, staticRenderFns } from "./SiteNotificationViewer.vue?vue&type=template&id=2207a7d6&"
import script from "./SiteNotificationViewer.vue?vue&type=script&lang=js&"
export * from "./SiteNotificationViewer.vue?vue&type=script&lang=js&"
import style0 from "./SiteNotificationViewer.vue?vue&type=style&index=0&id=2207a7d6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports